import React from "react";
import { SmartTableView } from "./ui/SmartTableView";

const SmartTable = (props) => {
  return <SmartTableView {...props} />;
};

export default SmartTable;
